import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { FC, ReactNode } from "react";
import {
  COLOR_BLACK,
  COLOR_PRIMARY_MAIN,
  COLOR_GREY_12,
} from "shared/theme/colors";
import {
  StyledBox,
  StyledButtonsPopup,
  StyledCancelButton,
  StyledResetPasswordButton,
  StyledModal,
  StyledTitle,
} from "./styled";

type ResetPasswordModalProps = {
  open: boolean;
  onClose: () => void;
  handleSuccess?: () => void;
  title: string;
  content?: string | ReactNode;
  applyButtonTitle?: string;
  cancelButtonTitle?: string;
  applyButtonLoading?: boolean;
  primaryButtonColor?: string;
  children?: React.ReactNode;
};

const ResetPasswordModal: FC<ResetPasswordModalProps> = ({
  open,
  onClose,
  handleSuccess,
  title,
  content,
  applyButtonTitle,
  cancelButtonTitle = "Cancel",
  applyButtonLoading = false,
  primaryButtonColor = COLOR_PRIMARY_MAIN,
  children,
}) => (
  <StyledModal open={open} onClose={onClose}>
    <StyledBox>
      <Stack flexDirection="row">
        <StyledTitle variant="heading3" color={COLOR_BLACK}>
          {title}
        </StyledTitle>
      </Stack>
      {content && (
        <Typography variant="bodyLRegular" color={COLOR_GREY_12}>
          {content}
        </Typography>
      )}
      {children}
      <StyledButtonsPopup>
        <StyledCancelButton
          title={cancelButtonTitle}
          onClick={onClose}
          size="small"
          variant="outlined"
        />
        {applyButtonTitle && (
          <StyledResetPasswordButton
            title={applyButtonTitle}
            onClick={handleSuccess}
            size="small"
            loading={applyButtonLoading}
            buttonColor={primaryButtonColor}
          />
        )}
      </StyledButtonsPopup>
    </StyledBox>
  </StyledModal>
);

export default ResetPasswordModal;
